// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".priorityNum[data-v-5b133823]{text-align:left;margin:10px}.pictureWarn[data-v-5b133823]{margin-left:10px;color:red}", ""]);
// Exports
module.exports = exports;
